import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import TR from './../../Trans';
import ExternalViewCommands from './../../services/external';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import playerStore from '../../stores/player';

function CurrentTime() {

  const currentTime = playerStore((state) => state.currentTime);
  const settings = settingsStore((state) => state.settings);
  const playQueue = performanceStore((state) => state.playQueue);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const countdown = performanceStore((state) => state.countdown);
  const setPlayQueueTrackList = performanceStore((state) => state.setPlayQueueTrackList);
  const setNextSingerTitle = performanceStore((state) => state.setNextSingerTitle);

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / (3600));
    var minutes = Math.floor(sec_num / 60) % 60;
    if (hours > 0) {
      return hours + "h " + minutes;
    } else {
      return minutes;
    }
  };
  const playQueueListStr = () => {


    if (settings) {
      let autoPlaySecs = settings.autoplay_enabled ? settings.autoplay_secs : 0;
      let list = TR.cm_after_this + ": ";
      if (playQueue) {
        let currentTimeDef = currentTime ? currentTime : 0;
        for (let i = 1; i < Math.min(settings.num_singers_shown + 1, playQueue.items.length); i++) {
          if (!nextPerformance) {
            list += playQueue.items[i].profile.name + " (" + toMinutes((playQueue.items[i].incoming + i * autoPlaySecs - currentTimeDef)) + " min)";
          } else {
            list += playQueue.items[i].profile.name + " (" + toMinutes((playQueue.items[i].incoming + i * autoPlaySecs + countdown - currentTimeDef)) + " min)";
          }
          if (i < Math.min(settings.num_singers_shown + 1, playQueue.items.length) - 1) {
            list += ", ";
          }
        }
        if (Math.min(settings.num_singers_shown + 1, playQueue.items.length) > 1) {
          return list;
        } else {
          return "";
        }
      }
    }
  };

  const emitPlayQueueListStr = () => {


    if (playQueue) {
      let str = playQueueListStr();
      setPlayQueueTrackList(str);
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueueTrackList\": \"" + str + "\"}')");
    } else {
      setPlayQueueTrackList("");
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"playQueueTrackList\": \"\"}')");
    }
  };

  const emitNextSingerTitle = () => {


    if (playQueue) {
      let nextSinger = playQueue.items.length > 1 ? TR.cm_next + ": " + playQueue.items[1].profile.name : "";
      setNextSingerTitle(nextSinger);
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextSingerTitle\": \"" + nextSinger + "\"}')");
    } else {
      setNextSingerTitle("");
      ExternalViewCommands.invokeJSOnExternalView("window.setPerformanceStore('{\"nextSingerTitle\": \"\"}')");
    }
  };

  useEffect(() => {
    if (currentTime) {
      emitPlayQueueListStr();
      emitNextSingerTitle();
    }
  }, [currentTime]);

}

export default CurrentTime;
